import { type FC } from 'react'

import { ProductVolumePricingBadge } from '../../../product'

import { useGenerateVolumePricingBadgeData } from './useGenerateVolumePricingBadgeData'

type ProductPageVolumePricingBadgeProps = {
  className?: string
}
export const ProductPageVolumePricingBadge: FC<
  ProductPageVolumePricingBadgeProps
> = ({ className }) => {
  const { discount, discountActivated, quantity } =
    useGenerateVolumePricingBadgeData()

  if (!discount || !quantity) {
    return null
  }

  return (
    <ProductVolumePricingBadge
      className={className}
      discount={discount}
      discountActivated={discountActivated}
      quantity={quantity}
    />
  )
}
